import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity } from "react-native"


import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';
import { useQuery } from '@tanstack/react-query';
import api from '../../../utils/api';
import { Image } from 'expo-image';
import QRCode from 'react-native-qrcode-svg';

import dayjs from 'dayjs'
import 'dayjs/locale/es'
dayjs.locale('es')

export default function EntryPassDetail({ route }) {
  const {passId} = route.params

  const { isLoading, error, data : entryPass, refetch } = useQuery({
    queryKey: ['entry-passes', passId],
    queryFn: () => api.get(`/entry-passes/${passId}`).then(response => response.data),
  })

  const entryDate = dayjs(entryPass?.data?.entry_date)
  const entryTime = dayjs(entryPass?.data?.entry_time)

  const entryDateLimit = entryPass?.data?.entry_date_limit ? dayjs(entryPass?.data?.entry_date_limit) : null
  const entryTimeLimit = entryPass?.data?.entry_time_limit ? dayjs(entryPass?.data?.entry_time_limit) : null

  const days = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do']

  function renderDays() {
    return (
      <View style={tw`row gap-x-2`}>
        {
          entryPass.data?.valid_days?.map((valid, index) =>
            valid ? <Text key={index} style={tw`text-gray-400`}>{days[index]}</Text> : null
          )
        }
      </View>
    )
  }

  return (
    <View style={tw`flex-1 justify-center items-center`}>
      {
        isLoading &&
          <Text>Cargando</Text>
      }

      {
        error &&
          <Text>Error al cargar el pase de entrada</Text>
      }

      {
        entryPass &&
          <View style={tw`items-center`}>
            <Text style={tw`text-xl mb-8`}>Pase de acceso</Text>


            <View style={tw` mb-6`}>
              {/* Fraccionamiento imagen / nombre */}
              <View style={tw`row`}>
                <View style={tw`rounded-full mr-3 w-10 h-10 bg-white overflow-hidden`}>
                  <Image style={tw`w-full h-full`} source={entryPass.community?.image_path} />
                </View>

                <Text style={tw`text-gray-500 text-lg`}>{entryPass.community?.name}</Text>
              </View>

              <Text style={tw`text-lg text-gray-600 text-center`}>{entryPass.unit.name}</Text>
              <Text style={tw`text-lg text-gray-600 text-center`}>{entryPass.guest_name}</Text>
              <Text style={tw`text-gray-400 text-center`}>{entryPass.periodicity_str}</Text>
            </View>


            <View
              style={tw.style(
                `mv-8`,
                // { transform: [{ rotate: '45deg' }], }
              )}
            >
              <View style={tw`p-4 bg-secondary rounded-xl`}>
                <QRCode
                  value={entryPass.url}
                  color={tw.color('primary')}
                  backgroundColor={tw.color('secondary')}
                  size={200}
                />
              </View>
            </View>

            <View style={tw`mt-6`}>
              <Text style={tw`text-gray-400`}>Validez:</Text>

              {
                entryPass.periodicity == "one_time" &&
                  <Text style={tw`text-gray-400 text-lg`}><Text style={tw`font-500 `}>{entryDate.format('ddd D-MM-YYYY')}</Text> {entryTime.format('hh:mm a')}</Text>
              }

              {
                entryPass.periodicity == "recurrent" &&
                  <View style={tw``}>
                    <View style={tw`row`}>
                      <Text style={tw`text-gray-400`}>{entryDate.format('D/MMM/YYYY')} al {entryDateLimit.format('D/MMM/YYYY')}</Text>
                    </View>

                    <View style={tw`row`}>
                      <Text style={tw`text-gray-400`}>De {entryTime.format('hh:mm a')} a {entryTimeLimit.format('hh:mm a')}</Text>
                    </View>

                    {renderDays()}
                  </View>
              }
            </View>

          </View>
      }
    </View>
  )
}

